class XMLDataSource {
	init(resourceConfiguration) {
		this._resourceConfiguration = resourceConfiguration;
		let initPromise = new Promise(this._initFunction.bind(this));
		return initPromise;
	}

	_initFunction(resolve, reject) {
		let Connect = new XMLHttpRequest();
		let { selectNodeParser, parsers } = this._resourceConfiguration.nodeParsers;
		Connect.open('GET', this._resourceConfiguration.path, true);
		Connect.setRequestHeader('Content-Type', 'text/xml');
		Connect.send(null);
		Connect.onload = function (e) {
			if (Connect.readyState === 4) {
			  if (Connect.status === 200) {
				let parser = new DOMParser();
				
				var cleanedXML = Connect.responseText.replaceAll('&','&amp;');
				cleanedXML = cleanedXML.replaceAll('<br>', '');
				cleanedXML = cleanedXML.replaceAll('<br/>', '<br></br>');
				var loadedXML = parser.parseFromString(cleanedXML, "application/xml");  
				let parsedXML = selectNodeParser(loadedXML, parsers)(loadedXML, parsers);
				resolve({data:parsedXML} );
			  } else {
				console.error(Connect.statusText);
				reject(Connect.statusText);
			  }
			}
		  };
		  Connect.onerror = function (e) {
			console.error(Connect.statusText);
			reject(Connect.statusText);
		  };
	
	}
}

export default XMLDataSource;